/* eslint-disable jsx-a11y/anchor-is-valid */
import bg_bg_4 from 'assets/media/bg/bg-4.jpg';
import { logoGreen } from 'images';
import { Link, Redirect, Switch } from 'react-router-dom';

import { ForgotPassword } from './ForgotPassword';
import Login from './Login';
import { ResetPassword } from './ResetPassword';

import '_metronic/_assets/css/login-1.css';

/**
 * Automatically generated by migrate-from-absolute-to-static-asset.ts */
import { ContentRoute } from '_metronic/layout';
export function AuthPage() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${bg_bg_4})`,
            }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <Link className="flex-column-auto mt-5 pb-lg-0 pb-10" to="/">
                <img alt="Logo" className="max-h-70px" src={logoGreen} />
              </Link>
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              <div className="flex-column-fluid d-flex flex-column justify-content-center">
                <h3 className="font-size-h1 mb-5 text-white">Welcome to Spazious!</h3>
                {/*<p className="font-weight-lighter text-white opacity-80">*/}
                {/*  The ultimate Bootstrap & React 16 admin theme framework for*/}
                {/*  next generation web apps.*/}
                {/*</p>*/}
              </div>
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-white">
                  &copy;
                  {` ${currentYear} Spazious`}
                </div>
                <div className="d-flex">
                  <Link className="text-white" to="/terms">
                    Privacy
                  </Link>
                  <Link className="text-white ml-10" to="/terms">
                    Legal
                  </Link>
                  <Link className="text-white ml-10" to="/terms">
                    Contact
                  </Link>
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <ContentRoute component={Login} path="/auth/login" />
                <ContentRoute component={ForgotPassword} path="/auth/forgot-password" />
                <ContentRoute component={ResetPassword} path="/auth/reset-password" />
                <Redirect exact={true} from="/auth" to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                {`© ${currentYear} Spazious`}
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link className="text-dark-75 text-hover-primary" to="/terms">
                  Privacy
                </Link>
                <Link className="text-dark-75 text-hover-primary ml-4" to="/terms">
                  Legal
                </Link>
                <Link className="text-dark-75 text-hover-primary ml-4" to="/terms">
                  Contact
                </Link>
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
